import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserClient } from '../schemas/types/shared';

interface UserState {
  data: UserClient | null;
  error: string | null;
}

const initialState: UserState = {
  data: null,
  error: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserClient | null>) => {
      state.data = action.payload;
    },
    clearUser(state) {
      state.data = null; // Очистка пользователя
    }
  }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
